<template>
    <section class="component">
        <section class="component__header">
            <span class="component__header__title">
                {{$t('com.file.footer-settings.graphic-footer')}}
            </span>
            <section class="component__header__action">
                <button class="component__button
                               component__button--small
                               component__button--white"
                        @click="selectAvatar" v-tooltip="$t('com.file.footer-settings.load-graphic')">
                    <img src="@/assets/icons/components/edit.svg" />
                    <span class="component__button__text">{{$t('com.global.select')}}</span>
                </button>
            </section>
            <section v-if="logo != null && logo.length > 0" class="component__header__action">
                <button class="component__button
                               component__button--small
                               component__button--white"
                        @click="deleteFooter" v-tooltip="$t('com.file.footer-settings.delete-graphic')">
                    <img src="@/assets/icons/components/delete.svg" />
                    <span class="component__button__text">{{$t('com.global.delete')}}</span>
                </button>
            </section>
        </section>
        <section class="avatar-info__item">
            <section class="avatar-info__item__label">{{$t('com.file.footer-settings.selected-graphic')}}:</section>
        </section>
        <section class="avatar-info__item2">{{$t('com.file.footer-settings.size-graphic')}}</section>

        <section v-if="logo != null && logo.length > 0" class="component__body avatar">
            <section class="avatar__picture">
                <img :src="logo" :alt="$t('com.file.footer-settings.graphic-footer')" class="avatar__picture__img" />
            </section>
        </section>
        <section v-else class="component__body avatar">
            <section class="avatar__picture">
                {{$t('com.file.footer-settings.no-selected-graphic')}}
            </section>
        </section>
    </section>
</template>
<script charset="utf-8">
    import SettingsService from "@/services/settings.service";
    import AlertHelper from '@/helpers/alerts.helper.js';

    export default {
        name: "LogoSettings",
        components: {

        },
        data() {
            return {
                rawAvatar: '',
                logo: null,
            }
        },
        mounted() {

            SettingsService.getFooterClientImage().then((response) => {

                if (response.status !== 200) {
                    this.logo = null;
                }

                this.logo = response.data.image;

            }).catch(() => {
                this.logo = null;
            });
        },
        methods: {
            async deleteFooter() {
                try {
                    this.$store.commit("showLoader");

                    let response = await SettingsService.deleteFooterClientImage();
                    if (response.status !== 200) {
                        throw await Promise.reject(response)
                    }

                    this.logo = '';
                }
                catch (e) {
                    if (e.response.status == 404) {
                        this.$router.push({ name: 'notfoundpage', params: { pathMatch: 'footersettings' } });
                    }
                    else if (e.response.status == 401) {
                        this.$router.push({ name: 'Login' })
                    }
                }
                finally {
                    this.showAvatarCropModal = false;
                    this.$store.commit("hideLoader");
                }
            },
            async updateAvatar() {
                try {
                    this.$store.commit("showLoader");

                    let request = {
                        image: this.rawAvatar,
                        userId: 0
                    }

                    let response = await SettingsService.setFooterClientImage(request);
                    if (response.status !== 200) {
                        throw await Promise.reject(response)
                    }

                    this.logo = this.rawAvatar;
                }
                catch (e) {
                    if (e.response.status == 404) {
                        this.$router.push({ name: 'notfoundpage', params: { pathMatch: 'footersettings' } });
                    }
                    else if (e.response.status == 401) {
                        this.$router.push({ name: 'Login' })
                    }
                }
                finally {
                    this.$store.commit("hideLoader");
                }
            },
            selectAvatar() {
                let input = document.createElement('input');
                input.type = 'file';
                input.accept = '.png';
                input.multiple = false;
                input.click();
                input.addEventListener('change', event => {
                    if (event.target.files.length == 0)
                        return;

                    let proposedFile = event.target.files[0];
                    if (proposedFile.size > 10000000) {
                        this.$swal(AlertHelper.errorAlert(this.$t('com.validation-error.invalid-file-size-info') + " 10MB", this.$t('com.global.error')));
                        return;
                    }

                    if (!this.checkMimeType(proposedFile.type)) {
                        this.$swal(AlertHelper.errorAlert(this.$t('com.validation-error.invalid-file-type-info') + " PNG", this.$t('com.global.error')));
                        return;
                    }

                    let reader = new FileReader();
                    reader.readAsDataURL(proposedFile);
                    reader.onload = e => {
                        this.rawAvatar = e.target.result;
                        if (this.rawAvatar.length > 0) {
                            this.updateAvatar();
                        }
                    }
                });
            },
            checkMimeType(type) {
                if (type != "image/png") {
                    return false;
                } else {
                    return true;
                }
            },
        }
    }
</script>
<style lang="scss" scoped>
    @use "@/assets/scss/user-profile-component.scss";

    .component {
        width: 450px;
        height: fit-content;
    }

    .avatar {
        display: flex;
        flex-direction: column;
        row-gap: 20px;
        padding: 15px 20px;
        align-items: center;
        justify-content: center;
        
        &__picture {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            &__img {
                max-width: 350px;
            }
        }

        &__actions {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }
    }

    .avatar-info {
        display: flex;
        flex-direction: column;
        row-gap: 10px;

        &__item {
            display: flex;
            flex-direction: row;
            column-gap: 10px;
            padding: 10px;
            text-align: center;

            &__label {
                font-weight: 800;
            }
        }

        &__item2 {
            display: flex;
            flex-direction: row;
            column-gap: 5px;
            padding: 5px;
            text-align: center;
        }
    }
</style>